import { RateModelDto } from "../ratemodeldto";

export class ParamLauncherDto {

    idpStudent!: number;

    idProductOrSubject!: number;

    numberTimesProductoOrSubjectRegistered!: number;

    numberCreditsForProductOrSubject!: number;

    typeRegistrationProcess!: string[];

    typology!: string[];

    rateModelDto: RateModelDto [] = [];

    isoLanguageCode!: string;

    academicRateType!: string;

    chargeLearningResources!: string[];

    learningResourceType!: string;

    statusProductOrSubject!: string[];

    experimentalCodeOfficialRegistration!: string;

    cycleCodeOfficialRegistration!: string;

}